<template>
    <div id="imgFullscreen">
        <img v-if="url" :src="url" alt="" style="width: 100%"/>
    </div>
</template>

<script>
import Img from "@/modules/img/components/service/Img";
import security from "@/main";

export default {
    name: "ImgFullscreen",

    data: () => ({
        header   : null,
        url      : null,
    }),

    methods: {
        setToken (header) {
            this.header = header;
        },

        /** [image]: an entry of a folder's images. */
        setImage (image) {
            const url = Img.imageUrl(image, "full");
            if (!url) {
                return;
            }
            fetch(url, {method: "GET", headers: security.jsonHeader()})
                .then(response => {
                    return response.blob().then(blob => {
                        const data = new Blob([blob], {type: response.headers.get("Content-Type")});
                        this.url = URL.createObjectURL(data);
                    })
                });
        }
    }
}
</script>

<style scoped>

</style>